import type { LucideIcon } from "lucide-react";

const SIZES = { xs: 12, sm: 14, md: 16, lg: 20, xl: 24, hero: 48 } as const;

export type IconSize = keyof typeof SIZES;

export function Icon({
  icon: Lucide,
  size = "md",
  className = "",
  strokeWidth = 2,
}: {
  icon: LucideIcon;
  size?: IconSize;
  className?: string;
  strokeWidth?: number;
}) {
  return <Lucide size={SIZES[size]} strokeWidth={strokeWidth} className={className} aria-hidden />;
}

export {
  Archive,
  ArrowLeftRight,
  Bell,
  Check,
  CircleCheck,
  Frown,
  Gavel,
  Gift,
  Hexagon,
  Home,
  KeyRound,
  Layers,
  Lock,
  MessageCircle,
  Package,
  Paperclip,
  PartyPopper,
  ShoppingBag,
  ShoppingCart,
  Ticket,
  Trophy,
  User,
  X,
  Eye,
} from "lucide-react";
